import { CHAT_MODEL } from "./model";
export const RULE = [
  {
    id: "chat",
    title: "聊天",
    detailList: [
      {
        funcName: "超时代AI 3.5",
        normal: -1,
        vip: -1,
        key: "gpt3",
      },
      // {
      //   funcName: "自研 4.0 文字模型",
      //   normal: -2,
      //   vip: -1,
      //   key: "doubao",
      // },
      {
        funcName: "GPT 4.0 文字模型",
        normal: -1,
        vip: -1,
        key: "gpt4",
      },
      {
        funcName: "GPT 4.0 写作模型",
        normal: -1,
        vip: -1,
        key: "claude",
      },
      {
        funcName: "GPT 4o 超强模型",
        normal: -1,
        vip: -1,
        key: "gpt4_all",
      },
      {
        funcName: "GPT o1 推理模型",
        normal: -1,
        vip: -1,
        // 暂时未定义，还未开放
        key: "gpt4o1",
      },
      {
        funcName: "GPT o3 推理模型",
        normal: -1,
        vip: -1,
        // 暂时未定义，还未开放
        key: "gpt4o3",
      },
      {
        funcName: "智能体对话",
        normal: -1,
        vip: -1,
        key: "non_chat",
      },
      {
        funcName: "DeepSeek R1 推理模型",
        normal: -1,
        vip: -1,
        key: "deep_seek_reasoner",
      },
    ],
  },
  {
    id: "draw",
    title: "绘图",
    detailList: [
      {
        funcName: "MX绘画",
        normal: -1,
        vip: -1,
        key: "SD文本生成",
      },
      {
        funcName: "MJ绘画（常规模式）",
        normal: -1,
        vip: -1,
        key: "MJ绘图",
      },
      {
        funcName: "MJ绘画（快速模式）",
        normal: -1,
        vip: -1,
        key: "MJ绘图快速",
      },
      {
        funcName: "图生图",
        normal: -1,
        vip: -1,
        key: "SD参考图生成",
      },
      {
        funcName: "动漫头像",
        normal: -1,
        vip: -1,
        key: "SD卡通头像",
      },
      {
        funcName: "智能重绘",
        normal: -1,
        vip: -1,
        key: "comfy_part_draw",
      },
      {
        funcName: "AI 消除笔",
        normal: -1,
        vip: -1,
        key: "SD重绘",
      },
    ],
  },
  {
    id: "aiTools",
    title: "AI工具",
    detailList: [
      {
        funcName: "文案配图神器",
        normal: 1,
        vip: 1,
        key: "illustration",
      },
      {
        funcName: "AI写真馆",
        normal: 10,
        vip: 5,
        key: "artistic_photo",
      },
      {
        funcName: "AI一键生成PPT",
        normal: -1,
        vip: -1,
        key: "ai_ppt",
      },
      {
        funcName: "AI思维导图",
        normal: -1,
        vip: -1,
        key: "ai_siweidaotu",
      },
      {
        funcName: "Suno AI音乐",
        normal: -1,
        vip: -1,
        key: "suno",
      },
      {
        funcName: "Luma 视频",
        normal: 200,
        vip: 150,
        key: "luma",
      },
      {
        funcName: "Pika 视频",
        normal: 200,
        vip: 150,
        key: "pika",
      },
      {
        funcName: "AI智能文档对话",
        normal: -1,
        vip: -1,
        key: "ai_document",
      },
    ],
  },
];

export function getRule(id, key) {
  const rule = RULE.find((r) => r.id === id);
  if (!rule) return;
  const detail = rule.detailList.find((d) => d.key === key);
  if (!detail) return;
  return detail;
}

export function formatPointText(ruleDetail = {}, pointRule = {}) {
  const formatObj = {
    normal: -1,
    normalText: "--",
    vip: -1,
    vipText: "--",
    key: ruleDetail?.key,
    isFormat: false,
  };
  if (!pointRule) return formatObj;
  formatObj.normal = pointRule.normal;
  formatObj.vip = pointRule.vip;
  if (ruleDetail.normal === -1) {
    if (pointRule.normal > 0)
      formatObj.normalText = `${pointRule.normal}积分/次`;
    else if (pointRule.normal === 0) formatObj.normalText = `免费`;
  }
  if (ruleDetail.normal === -2) {
    formatObj.normalText = `会员功能`;
  }
  if (ruleDetail.normal === -3) {
    formatObj.normalText = `暂未开放`;
  }
  if (ruleDetail.vip === -1) {
    if (pointRule.vip > 0) formatObj.vipText = `${pointRule.vip}积分/次`;
    else if (pointRule.vip === 0) formatObj.vipText = `会员免费`;
  }
  if (ruleDetail.vip === -3) {
    formatObj.vipText = `暂未开放`;
  }
  formatObj.isFormat = true;
  return formatObj;
}

export const RULE_COLUMN = [
  {
    title: "功能",
    dataIndex: "funcName",
    key: "funcName",
    minWidth: "147px",
  },
  {
    title: "非会员",
    dataIndex: "normal",
    key: "normal",
  },
  {
    title: "会员",
    dataIndex: "vip",
    key: "vip",
  },
];

export const COSTOMER_RULE = {
  gpt3_network: {
    normal: 0,
    vip: 0,
    key: "gpt3",
    normalOffset: 1,
    vipOffset: 1,
  },
  gpt4_network: {
    normal: 0,
    vip: 0,
    key: "gpt4",
    normalOffset: 1,
    vipOffset: 1,
  },
};

export const BUSINESS_TYPE = {
  0: "聊天任务",
  1: "Suno AI音乐",
  2: "SD图片缩放",
  3: "SD动漫风格转换",
  4: "SD卡通头像",
  5: "SD重绘",
  6: "SD去背景",
  7: "MJ绘图",
  8: "MJ图生文",
  9: "MJ混图",
  10: "MJ图片放大",
  11: "MJ图片U调整",
  12: "MJ图片V变幻",
  13: "MJ图片U动作",
  14: "SD图生文",
  15: "换脸",
  16: "SD扩图",
  17: "线搞上色",
  18: "智能消除",
  19: "AI商品图",
  20: "照片上色",
  21: "照片高清修复",
  22: "pika视频",
  23: "模特换装",
  24: "AI写真馆",
  25: "AI创意文字",
  26: "AI二维码",
  27: "文生视频",
  28: "文生视频高清",
  29: "图生视频",
  30: "图生视频高清",
  31: "runway gen2视频",
  // 32: "AI写真馆",
  33: "局部重绘/消除",
  34: "照片修复",
  35: "AI扩图",
  36: "图片转动漫",
  37: "风格迁移V2",
  38: "",
  39: "图片解析",
  40: "商品换背景",
  41: "条件生图",
  42: "无损放大",
  43: "照片上色",
  44: "AI抠图",
  45: "照片修复",
  46: "AI换脸",
  47: "",
  48: "视频换脸",
  49: "单人视频换脸", // ali
  50: "多人视频换脸", // ali
  51: "视频转动漫", // ali
  52: "动漫细节修复",
  53: "图片画质增强",
  54: "pika1.0文生视频",
  55: "pika1.0图生视频",
  56: "pika1.0视频局部重绘",
  57: "pika1.0视频扩展",
  58: "pika1.0视频配音",
  59: "图片转动漫V2", //ali
  61: "视频转动漫", //domo
  107: "视频转动漫", //domo
  108: "视频转动漫", //domo
  63: "pika1.0视频延时",
  64: "局部消除", //字节
  65: "局部重绘", //字节
  66: "图片画质增强", // 字节
  67: "视频换脸", // 字节
  62: "营销图海报",
  70: "luma 文生视频", // luma 文生视频
  71: "luma 图生视频", // luma 图生视频
  72: "SD3绘画",
  73: "故事连环画",
  74: "图片转素描",
  75: "图片转线稿",
  76: "luma扩展视频",
  77: "luma图生视频结尾帧",
  78: "照片修复上色",
  87: "viggle视频",
  89: "runway gen3视频",
  92: "kling文生标准视频",
  93: "kling文生高品质视频",
  94: "kling图生标准视频",
  95: "kling图生高品质视频",
  96: "kling视频延时",
  97: "图片转动漫V3",
  98: "风格迁移V3",
  100: "pika1.5文生视频",
  101: "pika1.5图生视频",
  105: "runway+文生视频",
  106: "runway+图生视频",
  666: "拼图",
  "-1": CHAT_MODEL["chat-normal"].name,
  "-2": CHAT_MODEL["chat-plus"].name,
  "-3": CHAT_MODEL.GPT4o.name,
  "-4": CHAT_MODEL["deep-seek"].name,
  "-5": CHAT_MODEL["GPT4.0"].name,
  "-6": CHAT_MODEL["GPTo1"].name,
  "-7": "百宝箱",
  "-8": "智能体",
};
